import React from "react";
import { Route } from "react-router-dom";
import Community from "../components/index";

const AboutRoutes = () => {
  return (
    <>
      <Route path="/community" element={<Community />} /> 
    </>
  );
};

export default AboutRoutes;
